var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmojiNeutralFace(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1027_761)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.9989 30.4978C25.3333 30.4978 29.9978 24.2303 29.9978 16.4989C29.9978 8.76751 25.3333 2.5 15.9989 2.5C6.66443 2.5 2 8.76751 2 16.4989C2 24.2303 6.66443 30.4978 15.9989 30.4978Z",
    fill: "url(#paint0_radial_1027_761)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9989 30.4978C25.3333 30.4978 29.9978 24.2303 29.9978 16.4989C29.9978 8.76751 25.3333 2.5 15.9989 2.5C6.66443 2.5 2 8.76751 2 16.4989C2 24.2303 6.66443 30.4978 15.9989 30.4978Z",
    fill: "url(#paint1_radial_1027_761)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9989 30.4978C25.3333 30.4978 29.9978 24.2303 29.9978 16.4989C29.9978 8.76751 25.3333 2.5 15.9989 2.5C6.66443 2.5 2 8.76751 2 16.4989C2 24.2303 6.66443 30.4978 15.9989 30.4978Z",
    fill: "url(#paint2_radial_1027_761)",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9989 30.4978C25.3333 30.4978 29.9978 24.2303 29.9978 16.4989C29.9978 8.76751 25.3333 2.5 15.9989 2.5C6.66443 2.5 2 8.76751 2 16.4989C2 24.2303 6.66443 30.4978 15.9989 30.4978Z",
    fill: "url(#paint3_radial_1027_761)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9989 30.4978C25.3333 30.4978 29.9978 24.2303 29.9978 16.4989C29.9978 8.76751 25.3333 2.5 15.9989 2.5C6.66443 2.5 2 8.76751 2 16.4989C2 24.2303 6.66443 30.4978 15.9989 30.4978Z",
    fill: "url(#paint4_radial_1027_761)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9989 30.4978C25.3333 30.4978 29.9978 24.2303 29.9978 16.4989C29.9978 8.76751 25.3333 2.5 15.9989 2.5C6.66443 2.5 2 8.76751 2 16.4989C2 24.2303 6.66443 30.4978 15.9989 30.4978Z",
    fill: "url(#paint5_radial_1027_761)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9989 30.4978C25.3333 30.4978 29.9978 24.2303 29.9978 16.4989C29.9978 8.76751 25.3333 2.5 15.9989 2.5C6.66443 2.5 2 8.76751 2 16.4989C2 24.2303 6.66443 30.4978 15.9989 30.4978Z",
    fill: "url(#paint6_radial_1027_761)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9.01705,
    cy: 13.9205,
    r: 4.6733,
    fill: "url(#paint7_radial_1027_761)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 19.2443,
    cy: 14.4432,
    r: 4.24431,
    fill: "url(#paint8_radial_1027_761)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4191 16.7244C12.742 16.7244 14.6251 14.8414 14.6251 12.5185C14.6251 10.1956 12.742 8.3125 10.4191 8.3125C8.09621 8.3125 6.21313 10.1956 6.21313 12.5185C6.21313 14.8414 8.09621 16.7244 10.4191 16.7244Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5683 16.8011C23.9123 16.8011 25.8126 14.9009 25.8126 12.5568C25.8126 10.2127 23.9123 8.3125 21.5683 8.3125C19.2242 8.3125 17.324 10.2127 17.324 12.5568C17.324 14.9009 19.2242 16.8011 21.5683 16.8011Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 15.5C12.6569 15.5 14 14.1569 14 12.5C14 10.8431 12.6569 9.5 11 9.5C9.34315 9.5 8 10.8431 8 12.5C8 14.1569 9.34315 15.5 11 15.5Z",
    fill: "url(#paint9_linear_1027_761)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21 15.5C22.6569 15.5 24 14.1569 24 12.5C24 10.8431 22.6569 9.5 21 9.5C19.3431 9.5 18 10.8431 18 12.5C18 14.1569 19.3431 15.5 21 15.5Z",
    fill: "url(#paint10_linear_1027_761)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 20.5C10 19.9477 10.4477 19.5 11 19.5H21C21.5523 19.5 22 19.9477 22 20.5C22 21.0523 21.5523 21.5 21 21.5H11C10.4477 21.5 10 21.0523 10 20.5Z",
    fill: "url(#paint11_linear_1027_761)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_1027_761",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(25.5 9.5) rotate(131.878) scale(38.9487)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF478"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.474827,
    stopColor: "#FFB02E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F70A8D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_1027_761",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(16 13) rotate(101.31) scale(17.8466 22.8581)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.787821,
    stopColor: "#F59639",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.972509,
    stopColor: "#FF7DCE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_1027_761",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(18 14.5) rotate(135) scale(41.0122)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.314853,
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_1027_761",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(16 17.5) rotate(77.692) scale(28.1469)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.507903,
    stopColor: "#7D6133",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#715B32"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_1027_761",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(16.5 17) rotate(55.7131) scale(13.3135 9.65032)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB849"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB847",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_1027_761",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(20.5 18.5) rotate(9.86581) scale(11.6726)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA64B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.900412,
    stopColor: "#FFAE46",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_1027_761",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(17.5 15.5) rotate(43.9708) scale(59.0529)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.185425,
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0.4
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_1027_761",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(12.6518 10.2857) rotate(135) scale(9.10579 4.71285)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#392108"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C87928",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_1027_761",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.5454 11.142) rotate(135) scale(7.66968 4.32966)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#392108"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C87928",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_1027_761",
    x1: 16.5,
    y1: 8.5,
    x2: 15.5,
    y2: 15.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#553B3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3D2432"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_1027_761",
    x1: 16.5,
    y1: 8.5,
    x2: 15.5,
    y2: 15.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#553B3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3D2432"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_1027_761",
    x1: 16,
    y1: 20,
    x2: 16,
    y2: 21,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F3C43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#512756"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1027_761"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmojiNeutralFace);
export default __webpack_public_path__ + "static/media/emoji-neutral-face.a1fec66e523a2ac1673dd0cd474e0e00.svg";
export { ForwardRef as ReactComponent };